import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'

class RxCommonType extends ActiveRecord {
  constructor(init) {
    super(init)
    // console.log('> Financial constructor -', init)
    if (isNil(init)) return undefined
    this._claim_id = init.claim_id
    this._medication = init.medication
  }

  static shape = {
    claim_id: PropTypes.string,
    medication: PropTypes.string
  }

  get claim_id() {
    return this._claim_id
  }

  get medication() {
    return this._medication
  }
}

export default RxCommonType
